// extracted by mini-css-extract-plugin
export default {"container":"F7CGtue","notificationContainer":"FitrpLe","link":"PMznYv3 TYb4J9A EVhxZk8 leavesden2"};